import { useEffect, useState } from 'react';
import useSWR from 'swr';
import config from '../config';

const { apiUrl } = config;
const apiPath = 'translations';

const fetcher = ([path, user, project]) => fetch(
  `${apiUrl}/${path}/${user}/${project}`,
  {
    headers: {
      'Content-type': 'application/json',
      Accept: 'application/json',
      Authorization: 'test',
    },
    mode: 'cors',
  },
).then((res) => res.json());

export default function useTranslations({ user, project }) {
  const [isLastPage, setIsLastPage] = useState(false);
  const {
    data, error, isLoading, mutate,
  } = useSWR([apiPath, user, project], fetcher);

  useEffect(() => {
    if (data?.items.length > 0 && !data?.lastEvaluatedKey) {
      setIsLastPage(true);
    } else {
      setIsLastPage(false);
    }
  }, [data]);

  const addTranslation = (transData) => {
    console.debug(`Add Translation  ${JSON.stringify(transData)}`);

    return fetch(
      `${apiUrl}/${apiPath}/`,
      {
        headers: {
          'Content-type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'origin',
          Authorization: 'test',
        },
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify({
          user,
          project,
          ...transData,
        }),
      },
    ).then((response) => {
      console.log(response);
      console.log(user);
      console.log(project);
      if (response.ok) {
        console.log(`mutate translation; data is ${data}`);
        mutate();
      }
    });
  };

  const importTranslations = (filedata, pluginname) => {
    console.debug(`Add Translation  ${JSON.stringify(filedata)}`);

    return fetch(

      `https://njdg9cbemg.execute-api.eu-west-1.amazonaws.com/dev/${user}/${project}/${pluginname}/translationimport`,

      {
        headers: {
          'Content-type': 'application/zip',
          Accept: 'application/json',
          'X-Requested-With': 'origin',
          Authorization: 'test',
        },
        method: 'POST',
        mode: 'cors',
        body: filedata,
      },
    ).then((response) => {
      console.log(response);
      console.log(user);
      console.log(project);
      if (response.ok) {
        console.log(`mutate translation; data is ${data}`);
        mutate();
        return 'success';
      }
      return 'error';
    }).catch((Error) => {
      // Handle the error here
      console.error('Error:', Error);
      return 'error';
    });
  };
  const updateTranslation = (transData) => fetch(
    `${apiUrl}/${apiPath}/${user}/${project}/${transData.trkey}`,
    {
      headers: {
        'Content-type': 'application/json',
        Accept: 'application/json',
        Authorization: 'test',
      },
      method: 'PUT',
      mode: 'cors',
      body: JSON.stringify({
        ...transData,
      }),
    },
  ).then((response) => {
    if (response.ok) {
      console.log(`mutate translation; data is ${data}`);
      mutate();
    }
  });

  const deleteTranslation = (key) => fetch(
    `${apiUrl}/${apiPath}/${user}/${project}/${key}`,
    {
      headers: {
        'Content-type': 'application/json',
        Accept: 'application/json',
        Authorization: 'test',
      },
      mode: 'cors',
      method: 'DELETE',
    },
  ).then((response) => {
    if (response.ok) {
      console.debug('mutate translation delete');
      mutate();
    }
  });

  const setPage = (newPage) => {
    mutate((cachedData) => ({
      ...cachedData,
      page: newPage,
    }));
  };

  const downloadTranslation = (pluginname) => fetch(
    ` https://njdg9cbemg.execute-api.eu-west-1.amazonaws.com/dev/${apiPath}/${user}/${project}/${pluginname}/dbToS3`,
    {
      headers: {
        'Content-type': 'application/json',
        Accept: 'application/json',
        Authorization: 'test',
      },
      mode: 'cors',
      method: 'GET',
    },
  ).then((response) => {
    if (response.ok) {
      return response.json();
      // mutate();
    }
    return 'Error';
  });
  const getplugin = () => fetch(
    ` https://njdg9cbemg.execute-api.eu-west-1.amazonaws.com/dev/${apiPath}/${user}/Plugintraverse`,
    {
      headers: {
        'Content-type': 'application/json',
        Accept: 'application/json',
        Authorization: 'test',
      },
      mode: 'cors',
      method: 'GET',
    },
  ).then((response) => {
    if (response.ok) {
      return response.json();
      // mutate();
    }
    return 'Error';
  });

  return {
    translations: data ? data.items : [],
    isLoading,
    isError: error,
    addTranslation,
    updateTranslation,
    deleteTranslation,
    count: data ? data.count : 0,
    onPageChange: setPage,
    isLastPage,
    downloadTranslation,
    getplugin,
    importTranslations,
  };
}
